import * as React from 'react'
import * as styles from './index.scss'

const ServerError = () => (
  <div className={styles.centered}>
    <div className={styles.emoji}>😵</div>
    <p className={styles.title}>Server Error</p>
    <p>申し訳ございません。サーバーエラーが発生しました。</p>
    <p>しばらくしてから再度お試しください。</p>
  </div>
)

export default ServerError
